var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customizer-external-includes-korea-headers"
  }, [_c('div', {
    class: ['header-container', {
      'expanded': _vm.showHeaderContainer
    }, {
      'show-dropdown': _vm.showCountryDropdown
    }]
  }, [_c('div', {
    staticClass: "main-header-container vans-korea"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('a', {
    attrs: {
      "href": _vm.baseUrl
    }
  }, [_c('div', {
    staticClass: "brand-logo"
  })])]), _c('div', {
    staticClass: "upper-right-area"
  }, [_c('ul', {
    staticClass: "upper-right-bar"
  }, [_c('li', {
    staticClass: "country-bar",
    on: {
      "click": function click($event) {
        return _vm.clickCountryBar(true);
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('svg', {
    attrs: {
      "width": "10px",
      "viewBox": "0 0 460 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "d": "M5 185.466l67.589-67.615 157.423 157.399 157.399-157.399 67.589 67.615-224.988 224.988z"
    }
  })]), _c('span', [_vm._v("지역")])]), _c('ul', {
    ref: "headerDropdown",
    class: ['country-dropdown', {
      'expanded': _vm.showCountryDropdown
    }],
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "focusout": _vm.focusoutCountryDropdown
    }
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _c('li'), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _vm._m(14), _vm._m(15), _vm._m(16), _vm._m(17), _vm._m(18), _vm._m(19), _vm._m(20), _vm._m(21), _vm._m(22), _vm._m(23), _vm._m(24), _vm._m(25), _vm._m(26), _vm._m(27), _vm._m(28), _vm._m(29), _vm._m(30)])]), _c('li', {
    staticClass: "location-bar"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/map")
    }
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "viewBox": "0 0 792 1024"
    }
  }, [_c('path', {
    attrs: {
      "d": "M736.97 366.932c0-201.956-153.6-366.932-341.334-366.932s-341.334 164.978-341.334 366.932v2.844c0 295.822 301.512 634.31 301.512 634.31 11.378 11.378 25.6 19.912 39.822 19.912v0c14.222 0 28.444-5.688 39.822-19.912 2.844-5.688 301.512-347.022 301.512-634.312v0-2.844zM395.636 512c-93.868 0-170.668-76.8-170.668-170.668s76.8-170.668 170.668-170.668 170.666 76.8 170.666 170.668-76.8 170.668-170.668 170.668z"
    }
  })]), _c('span', [_vm._v("STORE")])])]), _c('li', {
    staticClass: "cart-bar"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/cart")
    }
  }, [_c('svg', {
    attrs: {
      "width": "30px",
      "viewBox": "0 0 1114 1024"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20.732 46.289h222.66l84.675 247.749h765.208l-112.901 470.415h-589.586l-228.937-624.082-141.126 3.135v-97.217zM459.784 667.236h445.325l59.586-275.974h-598.993l94.082 275.974zM453.513 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811s87.811-37.632 87.811-87.811c3.135-50.179-37.632-87.811-87.811-87.811zM864.343 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811 50.179 0 87.811-37.632 87.811-87.811s-37.632-87.811-87.811-87.811z"
    }
  })]), _c('span', [_vm._v("쇼핑백")])])]), _c('li', {
    staticClass: "account-bar"
  }, [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/login")
    }
  }, [_c('svg', {
    attrs: {
      "width": "30",
      "viewBox": "0 0 458 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.947 495.832c0-45.81 0-86.231 0-133.389 55.242-25.6 110.484-51.2 168.421-78.147-14.821-43.116-32.337-80.842-41.769-121.263-10.779-47.158-12.126-99.706 40.421-122.611 28.294-12.127 71.411-12.127 99.706 1.347 49.853 24.252 49.853 76.8 37.726 123.958-9.432 39.073-26.947 74.106-43.116 117.221 56.589 26.947 114.526 53.894 171.116 79.495 0 47.158 0 87.579 0 132.042-145.516 1.348-288.337 1.348-432.505 1.348z"
    }
  })]), _c('span', [_vm._v("로그인")])])]), _c('li', {
    staticClass: "menu-bar",
    on: {
      "click": function click($event) {
        return _vm.clickMenuBar();
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('svg', {
    attrs: {
      "width": "30",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M32 96h448v96h-448zM32 224h448v96h-448zM32 352h448v96h-448z"
    }
  })])])])])]), _c('div', {
    class: ['nav-bar', {
      'expanded': _vm.showNavBar
    }]
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/category/new")
    }
  }, [_vm._v("NEW")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/category/men")
    }
  }, [_vm._v("MEN")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/category/women")
    }
  }, [_vm._v("WOMEN")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/category/kids")
    }
  }, [_vm._v("KIDS")])]), _c('li', [_c('a', {
    attrs: {
      "href": "".concat(_vm.baseUrl, "/category/custom")
    }
  }, [_vm._v("CUSTOMS")])])])]), _c('div', {
    class: ['hide-header', {
      'expanded': _vm.showHideHeader
    }],
    on: {
      "click": function click($event) {
        return _vm.clickHideHeader();
      }
    }
  }, [_c('div', {
    staticClass: "hide-indicator"
  }, [_c('svg', {
    attrs: {
      "width": "15px",
      "viewBox": "0 0 460 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M229.978 381.202l225.449-250.266h-450.897l225.447 250.266z"
    }
  })])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.kr/"
    }
  }, [_c('span', [_vm._v("대한민국")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.hk/en/"
    }
  }, [_c('span', [_vm._v("Hong Kong SAR")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.hk/"
    }
  }, [_c('span', [_vm._v("香港特別行政區")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://vans.com.cn/"
    }
  }, [_c('span', [_vm._v("中国")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.sg/"
    }
  }, [_c('span', [_vm._v("Singapore")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.in/"
    }
  }, [_c('span', [_vm._v("India")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com.my/"
    }
  }, [_c('span', [_vm._v("Malaysia")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.com/shop.html"
    }
  }, [_c('span', [_vm._v("USA")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.ca/en_ca/homepage.html"
    }
  }, [_c('span', [_vm._v("Canada (English)")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.ca/fr_ca/homepage.html"
    }
  }, [_c('span', [_vm._v("Canada (Français) ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.mx/es_mx/homepage.html"
    }
  }, [_c('span', [_vm._v("Méjico (Español) ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://vansdobrasil.com/"
    }
  }, [_c('span', [_vm._v("Brasil ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vansargentina.com/"
    }
  }, [_c('span', [_vm._v("Argentina ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.at/"
    }
  }, [_c('span', [_vm._v("Österreich ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.fr/"
    }
  }, [_c('span', [_vm._v("France ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.de/"
    }
  }, [_c('span', [_vm._v("Deutschland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.ie/"
    }
  }, [_c('span', [_vm._v("Ireland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Israel ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.it/"
    }
  }, [_c('span', [_vm._v("Italia ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.nl/"
    }
  }, [_vm._v(">\n                  "), _c('span', [_vm._v("Nederland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Polska ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.pt/"
    }
  }, [_c('span', [_vm._v("Portugal ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://vans.ru/"
    }
  }, [_c('span', [_vm._v("Россия ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.es/"
    }
  }, [_c('span', [_vm._v("España ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.se/"
    }
  }, [_c('span', [_vm._v("Sweden ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Switzerland ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.eu/"
    }
  }, [_c('span', [_vm._v("Türkiye ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.uk/"
    }
  }, [_c('span', [_vm._v("United Kingdom ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vansjapan.com/"
    }
  }, [_c('span', [_vm._v("日本 ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.net.au/"
    }
  }, [_c('span', [_vm._v("Australia ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('a', {
    attrs: {
      "href": "http://www.vans.co.nz/"
    }
  }, [_c('span', [_vm._v("New Zealand ")])])]);
}]

export { render, staticRenderFns }